import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: 300,
    backgroundColor: theme.palette.neutralLighterAlt,
  },
}));